import { jsxs as t, jsx as C } from "react/jsx-runtime";
const n = ({ size: i = 16, ...e }) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 35 24",
    fill: "none",
    ...e,
    children: [
      /* @__PURE__ */ C("rect", { x: "0.5", y: "0.5", width: "34", height: "23", rx: "3.5", fill: "white", stroke: "#E5E7EB" }),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M22.3182 12.2873C22.8319 12.2984 23.3485 12.2646 23.8601 12.3049C24.3782 12.4015 24.5031 13.1859 24.0428 13.4428C23.7287 13.612 23.3556 13.5058 23.0151 13.5357H22.3182V12.2873ZM24.1571 10.8743C24.2712 11.2771 23.8829 11.6388 23.4949 11.5833H22.3182C22.3264 11.2034 22.302 10.7911 22.3301 10.4312C22.8015 10.4445 23.2773 10.4041 23.746 10.4523C23.9473 10.5029 24.1159 10.6684 24.1571 10.8743ZM26.989 4.90042C27.0109 5.66972 26.9922 6.47968 26.9985 7.26459C26.997 10.4557 27.0016 13.6468 26.996 16.8381C26.9753 18.0341 25.9154 19.0733 24.7277 19.0971C23.5389 19.102 22.3499 19.0979 21.1609 19.0992V14.2749C22.4564 14.2682 23.7525 14.2884 25.0474 14.2647C25.6482 14.227 26.3062 13.8307 26.3341 13.1696C26.4049 12.5057 25.7789 12.0464 25.1846 11.9739C24.9561 11.968 24.9628 11.9073 25.1846 11.8808C25.7514 11.7583 26.1965 11.1717 26.0298 10.5841C25.8877 9.96618 25.2046 9.72701 24.6365 9.72819C23.4782 9.72032 22.3196 9.72709 21.1612 9.72481C21.1686 8.82416 21.1456 7.92255 21.1736 7.02256C21.2654 5.84819 22.352 4.87971 23.523 4.90073C24.6785 4.90055 25.8338 4.90055 26.989 4.90051V4.90042Z",
          fill: "url(#paint0_linear_965_639)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M8.07061 7.14441C8.10019 5.95034 9.16462 4.91967 10.3508 4.90222C11.5352 4.89857 12.7198 4.90169 13.9043 4.90064C13.901 8.89572 13.9107 12.8912 13.8994 16.8861C13.8538 18.0657 12.8009 19.0767 11.6277 19.0976C10.441 19.1019 9.25421 19.0982 8.06749 19.0994V14.1124C9.22019 14.3847 10.429 14.5006 11.6049 14.32C12.3079 14.2069 13.0769 13.8617 13.3149 13.1324C13.49 12.5086 13.3915 11.8521 13.4175 11.2119V9.72503H11.3824C11.3733 10.7084 11.4011 11.6935 11.3677 12.6757C11.3128 13.2794 10.715 13.663 10.1456 13.6425C9.43945 13.65 8.04014 13.1307 8.04014 13.1307C8.03663 11.2883 8.06063 8.98091 8.07061 7.14458V7.14441Z",
          fill: "url(#paint1_linear_965_639)"
        }
      ),
      /* @__PURE__ */ C(
        "path",
        {
          d: "M14.6632 10.3245C14.5561 10.3472 14.6417 9.9596 14.6143 9.81256C14.6216 8.88286 14.599 7.95214 14.6267 7.0231C14.7183 5.84376 15.8132 4.87287 16.9889 4.90048H20.4513C20.4481 8.89556 20.4577 12.8911 20.4465 16.886C20.4008 18.0655 19.3479 19.0765 18.1746 19.0974C16.9879 19.1019 15.8011 19.0981 14.6143 19.0993V13.6353C15.4248 14.3004 16.5264 14.4039 17.5362 14.4057C18.2974 14.4054 19.0542 14.2881 19.7935 14.1125V13.1115C18.9604 13.5267 17.981 13.7905 17.0575 13.5519C16.4133 13.3915 15.9456 12.7689 15.956 12.1041C15.8814 11.4127 16.2867 10.6827 16.9661 10.4772C17.8097 10.2131 18.7291 10.415 19.5198 10.7584C19.6893 10.8471 19.8612 10.9571 19.7935 10.674V9.88716C18.471 9.57251 17.0636 9.45672 15.7349 9.79902C15.3503 9.90751 14.9756 10.072 14.6632 10.3246V10.3245Z",
          fill: "url(#paint2_linear_965_639)"
        }
      ),
      /* @__PURE__ */ t("defs", { children: [
        /* @__PURE__ */ t(
          "linearGradient",
          {
            id: "paint0_linear_965_639",
            x1: "21.1211",
            y1: "11.6962",
            x2: "26.9617",
            y2: "11.6962",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ C("stop", { stopColor: "#58B03A" }),
              /* @__PURE__ */ C("stop", { offset: "1", stopColor: "#55B330" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "linearGradient",
          {
            id: "paint1_linear_965_639",
            x1: "7.9433",
            y1: "12.136",
            x2: "13.8086",
            y2: "12.136",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ C("stop", { stopColor: "#0F6EB6" }),
              /* @__PURE__ */ C("stop", { offset: "1", stopColor: "#006DBA" })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "linearGradient",
          {
            id: "paint2_linear_965_639",
            x1: "14.6057",
            y1: "11.8338",
            x2: "20.4503",
            y2: "11.8338",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ C("stop", { stopColor: "#DE0D3D" }),
              /* @__PURE__ */ C("stop", { offset: "1", stopColor: "#E30138" })
            ]
          }
        )
      ] })
    ]
  }
);
export {
  n as JSBIcon
};
